const _ = require('underscore');
const analytics = require('core/analytics');
const analyticsService = require('services/analyticsService');
const routeContext = require('core/routeContext');
const logger = require('utilities/logger');
const model = require('model/model');
const pubsub = require('events/pubsub');

const OUTBOUND_LINK = 'OUTBOUND_LINK';
const TOKEN_EXPIRED = 'TOKEN_EXPIRED';
const PRINT = 'PRINT';
const STUDENT_ELL_CHANGE = 'STUDENT_ELL_CHANGE';
const INDIVIDUAL_STUDENT_PROGRESS_VIEW = 'INDIVIDUAL_STUDENT_PROGRESS_VIEW';
const TTS_TOGGLE_ON = 'TTS_TOGGLE_ON';
const TTS_TOGGLE_OFF = 'TTS_TOGGLE_OFF';
const TTS_PLAY = 'TTS_PLAY';
const TTS_PAUSE = 'TTS_PAUSE';
const TTS_COMPLETE = 'TTS_COMPLETE';
const AUDIO_PLAY = 'AUDIO_PLAY';
const AUDIO_PAUSE = 'AUDIO_PAUSE';
const AUDIO_COMPLETE = 'AUDIO_COMPLETE';
const WORKSPACE_TOOL_CLICK = 'WORKSPACE_TOOL_CLICK';
const WORKSPACE_TAB_CLICK = 'WORKSPACE_TAB_CLICK';
const TEACHER_OPEN_WORKSPACE = 'TEACHER_OPEN_WORKSPACE';
const CVA_PREVIEW = 'CVA_PREVIEW';
const CVA_OPEN_ASSIGN_MODAL = 'CVA_OPEN_ASSIGN_MODAL';
const CVA_STUDENT_ANSWER_QUESTION = 'CVA_STUDENT_ANSWER_QUESTION';
const WHITEBOARD_VIEW_ACTIVATE = 'WHITEBOARD_VIEW_ACTIVATE';
const WHITEBOARD_VIEW_DEACTIVATE = 'WHITEBOARD_VIEW_DEACTIVATE';
const PREVIEW_PRODUCT = 'PREVIEW_PRODUCT';
const OPEN_ASSIGN_MODAL = 'OPEN_ASSIGN_MODAL';
const OPEN_PRINT_MODAL = 'OPEN_PRINT_MODAL';
const PREVIEW_STEPREAD = 'PREVIEW_STEPREAD';
const PREVIEW_EBOOK = 'PREVIEW_EBOOK';
const PREVIEW_QUESTIONS = 'PREVIEW_QUESTIONS';
const PREVIEW_BOK = 'PREVIEW_BOK';
const PREVIEW_ARTICLE = 'PREVIEW_ARTICLE';
const FETCH_PRODUCT = 'FETCH_PRODUCT';
const ADD_COTEACHER = 'ADD_COTEACHER';
const ACCEPT_COTEACHER = 'ACCEPT_COTEACHER';
const REMOVE_COTEACHER = 'REMOVE_COTEACHER';
const COTEACHER_LEAVE_CLASS = 'COTEACHER_LEAVE_CLASS';
const SEARCH_SUGGESTION_CLICK = 'SEARCH_SUGGESTION_CLICK';
const ASSIGN_TRACKED_ASSIGNMENT = 'ASSIGN_TRACKED_ASSIGNMENT';
const REASSIGN_ASSIGNMENT = 'REASSIGN_ASSIGNMENT';
const NEXT_PAGE_EBOOK = 'NEXT_PAGE_EBOOK';
const PREVIOUS_PAGE_EBOOK = 'PREVIOUS_PAGE_EBOOK';
const GOTO_PAGE_EBOOK = 'GOTO_PAGE_EBOOK';
const EBOOK_AUDIO_PLAY = 'EBOOK_AUDIO_PLAY';
const EBOOK_AUDIO_PAUSE = 'EBOOK_AUDIO_PAUSE';
const EBOOK_AUDIO_COMPLETE = 'EBOOK_AUDIO_COMPLETE';
const ELL_AUDIO_PLAY = 'ELL_AUDIO_PLAY';
const ELL_AUDIO_PAUSE = 'ELL_AUDIO_PAUSE';
const ELL_AUDIO_COMPLETE = 'ELL_AUDIO_COMPLETE';
const NATIVE_PRINT = 'NATIVE_PRINT';
const EXPORT_CSV = 'EXPORT_CSV';
const PRODUCT_PREVIEW_COPY = 'PRODUCT_PREVIEW_COPY';
const CAMPAIGN_LANDED = 'CAMPAIGN_LANDED';
const HOMEPAGE_CLICK = 'HOMEPAGE_CLICK';
const PARENT_DONATE_POPUP_OPENED = 'PARENT_DONATE_POPUP_OPENED';
const SOCIAL_MEDIA_SHARE = 'SOCIAL_MEDIA_SHARE';
const PRODUCT_PROMOTION_CLICK = 'PRODUCT_PROMOTION_CLICK';
const ONBOARDING = 'ONBOARDING';
const REMOVE_FROM_BINDER = 'REMOVE_FROM_BINDER';
const ADD_TO_BINDER = 'ADD_TO_BINDER';
const GET_CLASS_ASSIGNMENTS = 'GET_CLASS_ASSIGNMENTS';
const UPDATE_ACCOUNT_SETTING = 'UPDATE_ACCOUNT_SETTING';
const OPEN_BINDER = 'OPEN_BINDER';
const VIDEO_PLAY = 'VIDEO_PLAY';
const VIDEO_PAUSE = 'VIDEO_PAUSE';
const VIDEO_COMPLETE = 'VIDEO_COMPLETE';
const PREVIEW_VIDEO = 'PREVIEW_VIDEO';
const MAZE_ASSIGN = 'MAZE_ASSIGN';
const MAZE_AAD_ASSIGN = 'MAZE_AAD_ASSIGN';
const MAZE_START = 'MAZE_START';
const MAZE_STUDENT_ANSWER_QUESTION = 'MAZE_STUDENT_ANSWER_QUESTION';
const CBOK_OPEN = 'CBOK_OPEN';
const CBOK_OPEN_SET = 'CBOK_OPEN_SET';
const CBOK_CLOSE_SET = 'CBOK_CLOSE_SET';
const CBOK_CLOSE_ALL_SETS = 'CBOK_CLOSE_ALL_SETS';
const CBOK_SORT = 'CBOK_SORT';
const CBOK_CREATE_ENTRY = 'CBOK_CREATE_ENTRY';
const CBOK_EDIT_ENTRY = 'CBOK_EDIT_ENTRY';
const CBOK_DELETE_ENTRY = 'CBOK_DELETE_ENTRY';
const CBOK_POST_STUDENT_ENTRY = 'CBOK_POST_STUDENT_ENTRY';
const CBOK_REMOVE_STUDENT_ENTRY = 'CBOK_REMOVE_STUDENT_ENTRY';
const SKI_ASSIGN = 'SKI_ASSIGN';
const SKI_START = 'SKI_START';
const SKI_STUDENT_ANSWER_QUESTION = 'SKI_STUDENT_ANSWER_QUESTION';
const SKI_VIEW_RESULTS = 'SKI_VIEW_RESULTS';
const SKI_ABOUT_VIEW = 'SKI_ABOUT_VIEW';
const SKI_PREVIEW = 'SKI_PREVIEW';
const SL_ADMIN_CLICK = 'SL_ADMIN_CLICK';
const SL_TOGGLE = 'SL_TOGGLE';
const SL_ASSIGNMENTS_TOGGLE = 'SL_ASSIGNMENTS_TOGGLE';
const SL_PREVIEW_OPEN = 'SL_PREVIEW_OPEN';
const SL_PREVIEW_EXIT = 'SL_PREVIEW_EXIT';
const SL_LIBRARY_OPEN = 'SL_LIBRARY_OPEN';
const SL_SETTINGS_OPEN = 'SL_SETTINGS_OPEN';
const SL_SETTINGS_CLOSE = 'SL_SETTINGS_CLOSE';
const SL_UPDATE_INTERESTS = 'SL_UPDATE_INTERESTS';
const SL_UPDATE_SKF = 'SL_UPDATE_SKF';
const SL_UPDATE_THEME = 'SL_UPDATE_THEME';
const SL_TOOL_CLICK = 'SL_TOOL_CLICK';
const SL_SEARCH_UI = 'SL_SEARCH_UI';
const SL_SEARCH = 'SL_SEARCH';
const SL_LIST = 'SL_LIST';
const SL_LOG = 'SL_LOG';
const SL_HOME = 'SL_HOME';
const SL_BOOKMARK = 'SL_BOOKMARK';
const SL_ARTICLE_VIEW = 'SL_ARTICLE_VIEW';
const SL_ARTICLE_FINISH = 'SL_ARTICLE_FINISH';
const SL_FAVORITE = 'SL_FAVORITE';
const SL_LOG_FILTER = 'SL_LOG_FILTER';
const SL_LOG_EDIT = 'SL_LOG_EDIT';
const STUDENT_HOME = 'STUDENT_HOME';
const VIEW_START = 'VIEW_START';
const VIEW_END = 'VIEW_END';
const WORDSMYTH_LOGO_HOVER = 'WORDSMYTH_LOGO_HOVER';
const SL_PROMO = 'SL_PROMO';
const SL_PROMO_CLICK = 'SL_PROMO_CLICK';
const NAV_CLICK = 'NAV_CLICK';
const PREVIEW_WD = 'PREVIEW_WD';
const PREVIEW_MM = 'PREVIEW_MM';
const SCOPE_SEQUENCE_CREATED = 'SCOPE_SEQUENCE_CREATED';
const VOCAB_WIDGET_OPEN = 'VOCAB_WIDGET_OPEN';
const VOCAB_WIDGET_CLOSE = 'VOCAB_WIDGET_CLOSE';
const SCOPE_SEQUENCE_VIEW = 'SCOPE_SEQUENCE_VIEW';
const SCOPE_SEQUENCE_CLICK = 'SCOPE_SEQUENCE_CLICK';
const SCOPE_SEQUENCE_FILTER = 'SCOPE_SEQUENCE_FILTER';
const SCOPE_SEQUENCE_ASSIGN_OPEN = 'SCOPE_SEQUENCE_ASSIGN_OPEN';
const SCOPE_SEQUENCE_PROMO_CLICK = 'SCOPE_SEQUENCE_PROMO_CLICK';
const WORDSMYTH_AUDIO_PLAY = 'WORDSMYTH_AUDIO_PLAY';
const WORDSMYTH_AUDIO_PAUSE = 'WORDSMYTH_AUDIO_PAUSE';
const WORDSMYTH_AUDIO_COMPLETE = 'WORDSMYTH_AUDIO_COMPLETE';
const VOCAB_BUILDER_AUDIO_PLAY = 'VOCAB_BUILDER_AUDIO_PLAY';
const VOCAB_BUILDER_AUDIO_PAUSE = 'VOCAB_BUILDER_AUDIO_PAUSE';
const VOCAB_BUILDER_AUDIO_COMPLETE = 'VOCAB_BUILDER_AUDIO_COMPLETE';
const VOCAB_CHANGER_AUDIO_PLAY = 'VOCAB_CHANGER_AUDIO_PLAY';
const VOCAB_CHANGER_AUDIO_PAUSE = 'VOCAB_CHANGER_AUDIO_PAUSE';
const VOCAB_CHANGER_AUDIO_COMPLETE = 'VOCAB_CHANGER_AUDIO_COMPLETE';
const VOCAB_MATCHER_AUDIO_PLAY = 'VOCAB_MATCHER_AUDIO_PLAY';
const VOCAB_MATCHER_AUDIO_PAUSE = 'VOCAB_MATCHER_AUDIO_PAUSE';
const VOCAB_MATCHER_AUDIO_COMPLETE = 'VOCAB_MATCHER_AUDIO_COMPLETE';
const AUDIO_SPEED_CHANGE = 'AUDIO_SPEED_CHANGE';
const DOWNLOAD_ASSIGNMENT = 'DOWNLOAD_ASSIGNMENT';
const CLEAR_ASSIGNMENT = 'CLEAR_ASSIGNMENT';
const OLM_ON = 'OLM_ON';
const OLM_OFF = 'OLM_OFF';
const SUBMIT_OFFLINE_ASSIGNMENT = 'SUBMIT_OFFLINE_ASSIGNMENT';
const REMOVE_STUDENT_FROM_ASSIGNMENT = 'REMOVE_STUDENT_FROM_ASSIGNMENT';
const VOCAB_RATE_THE_WORD = 'VOCAB_RATE_THE_WORD';
const VOCAB_ACTIVITY_COMPLETE = 'VOCAB_ACTIVITY_COMPLETE';
const VOCAB_ACTIVITY_RESET = 'VOCAB_ACTIVITY_RESET';
const PREVIEW_VOCAB = 'PREVIEW_VOCAB';
const TEACHER_GUIDE_LINK = 'TEACHER_GUIDE_LINK';
const PAGE_VIEW = 'PAGE_VIEW';
const RECOMMENDATION_CLICK = 'RECOMMENDATION_CLICK';
const WHITEBOARD_TOOL_CLICK = 'WHITEBOARD_TOOL_CLICK';
const JOURNEY_ACTION = 'JOURNEY_ACTION';
const BUTTER_BAR_DISMISSED = 'BUTTER_BAR_DISMISSED';
const LISTENING_LEVEL_BUTTER_BAR_HIDDEN = 'LISTENING_LEVEL_BUTTER_BAR_HIDDEN';
const SRA_STEP_START = 'SRA_STEP_START';
const SRA_STUDENT_ANSWER_QUESTION = 'SRA_STUDENT_ANSWER_QUESTION';
const SRA_MODAL_OPENED = 'SRA_MODAL_OPENED';
const SRA_SUBMIT = 'SRA_SUBMIT';
const SHOW_RECOMMENDATIONS = 'SHOW_RECOMMENDATIONS';
const RECOMMENDATION_PANEL_ACTION = 'RECOMMENDATION_PANEL_ACTION';
const NEXT_STUDENT = 'NEXT_STUDENT';
const PREVIOUS_STUDENT = 'PREVIOUS_STUDENT';

const events = {
	OUTBOUND_LINK,
	TOKEN_EXPIRED,
	PRINT,
	STUDENT_ELL_CHANGE,
	INDIVIDUAL_STUDENT_PROGRESS_VIEW,
	TTS_TOGGLE_ON,
	TTS_TOGGLE_OFF,
	TTS_PLAY,
	TTS_PAUSE,
	TTS_COMPLETE,
	AUDIO_PLAY,
	AUDIO_PAUSE,
	AUDIO_COMPLETE,
	WORKSPACE_TOOL_CLICK,
	WORKSPACE_TAB_CLICK,
	TEACHER_OPEN_WORKSPACE,
	CVA_PREVIEW,
	CVA_OPEN_ASSIGN_MODAL,
	CVA_STUDENT_ANSWER_QUESTION,
	WHITEBOARD_VIEW_ACTIVATE,
	WHITEBOARD_VIEW_DEACTIVATE,
	PREVIEW_PRODUCT,
	OPEN_ASSIGN_MODAL,
	OPEN_PRINT_MODAL,
	PREVIEW_STEPREAD,
	PREVIEW_EBOOK,
	PREVIEW_QUESTIONS,
	PREVIEW_BOK,
	PREVIEW_ARTICLE,
	FETCH_PRODUCT,
	ADD_COTEACHER,
	ACCEPT_COTEACHER,
	REMOVE_COTEACHER,
	COTEACHER_LEAVE_CLASS,
	SEARCH_SUGGESTION_CLICK,
	ASSIGN_TRACKED_ASSIGNMENT,
	REASSIGN_ASSIGNMENT,
	NEXT_PAGE_EBOOK,
	PREVIOUS_PAGE_EBOOK,
	GOTO_PAGE_EBOOK,
	EBOOK_AUDIO_PLAY,
	EBOOK_AUDIO_PAUSE,
	EBOOK_AUDIO_COMPLETE,
	ELL_AUDIO_PLAY,
	ELL_AUDIO_PAUSE,
	ELL_AUDIO_COMPLETE,
	NATIVE_PRINT,
	EXPORT_CSV,
	PRODUCT_PREVIEW_COPY,
	CAMPAIGN_LANDED,
	HOMEPAGE_CLICK,
	PARENT_DONATE_POPUP_OPENED,
	SOCIAL_MEDIA_SHARE,
	PRODUCT_PROMOTION_CLICK,
	ONBOARDING,
	REMOVE_FROM_BINDER,
	ADD_TO_BINDER,
	GET_CLASS_ASSIGNMENTS,
	UPDATE_ACCOUNT_SETTING,
	OPEN_BINDER,
	VIDEO_PLAY,
	VIDEO_PAUSE,
	VIDEO_COMPLETE,
	PREVIEW_VIDEO,
	MAZE_ASSIGN,
	MAZE_AAD_ASSIGN,
	MAZE_START,
	MAZE_STUDENT_ANSWER_QUESTION,
	CBOK_OPEN,
	CBOK_OPEN_SET,
	CBOK_CLOSE_SET,
	CBOK_CLOSE_ALL_SETS,
	CBOK_SORT,
	CBOK_CREATE_ENTRY,
	CBOK_EDIT_ENTRY,
	CBOK_DELETE_ENTRY,
	CBOK_POST_STUDENT_ENTRY,
	CBOK_REMOVE_STUDENT_ENTRY,
	SKI_ASSIGN,
	SKI_START,
	SKI_STUDENT_ANSWER_QUESTION,
	SKI_VIEW_RESULTS,
	SL_ADMIN_CLICK,
	SL_TOGGLE,
	SL_ASSIGNMENTS_TOGGLE,
	SL_PREVIEW_OPEN,
	SL_PREVIEW_EXIT,
	SL_LIBRARY_OPEN,
	SL_SETTINGS_OPEN,
	SL_SETTINGS_CLOSE,
	SL_UPDATE_INTERESTS,
	SL_UPDATE_SKF,
	SL_UPDATE_THEME,
	SL_TOOL_CLICK,
	SL_SEARCH_UI,
	SL_SEARCH,
	SL_LIST,
	SL_LOG,
	SL_HOME,
	SL_BOOKMARK,
	SL_ARTICLE_VIEW,
	SL_ARTICLE_FINISH,
	SL_FAVORITE,
	SL_LOG_FILTER,
	SL_LOG_EDIT,
	STUDENT_HOME,
	VIEW_START,
	VIEW_END,
	WORDSMYTH_LOGO_HOVER,
	SL_PROMO,
	SL_PROMO_CLICK,
	NAV_CLICK,
	PREVIEW_WD,
	PREVIEW_MM,
	SCOPE_SEQUENCE_CREATED,
	SCOPE_SEQUENCE_VIEW,
	SCOPE_SEQUENCE_CLICK,
	SCOPE_SEQUENCE_FILTER,
	SCOPE_SEQUENCE_ASSIGN_OPEN,
	SCOPE_SEQUENCE_PROMO_CLICK,
	VOCAB_WIDGET_OPEN,
	VOCAB_WIDGET_CLOSE,
	SKI_ABOUT_VIEW,
	SKI_PREVIEW,
	WORDSMYTH_AUDIO_PLAY,
	WORDSMYTH_AUDIO_PAUSE,
	WORDSMYTH_AUDIO_COMPLETE,
	VOCAB_BUILDER_AUDIO_PLAY,
	VOCAB_BUILDER_AUDIO_PAUSE,
	VOCAB_BUILDER_AUDIO_COMPLETE,
	VOCAB_CHANGER_AUDIO_PLAY,
	VOCAB_CHANGER_AUDIO_PAUSE,
	VOCAB_CHANGER_AUDIO_COMPLETE,
	VOCAB_MATCHER_AUDIO_PLAY,
	VOCAB_MATCHER_AUDIO_PAUSE,
	VOCAB_MATCHER_AUDIO_COMPLETE,
	AUDIO_SPEED_CHANGE,
	DOWNLOAD_ASSIGNMENT,
	CLEAR_ASSIGNMENT,
	OLM_ON,
	OLM_OFF,
	SUBMIT_OFFLINE_ASSIGNMENT,
	REMOVE_STUDENT_FROM_ASSIGNMENT,
	VOCAB_RATE_THE_WORD,
	VOCAB_ACTIVITY_COMPLETE,
	VOCAB_ACTIVITY_RESET,
	PREVIEW_VOCAB,
	PAGE_VIEW,
	TEACHER_GUIDE_LINK,
	RECOMMENDATION_CLICK,
	WHITEBOARD_TOOL_CLICK,
	JOURNEY_ACTION,
	BUTTER_BAR_DISMISSED,
	LISTENING_LEVEL_BUTTER_BAR_HIDDEN,
	SRA_STEP_START,
	SRA_STUDENT_ANSWER_QUESTION,
	SRA_MODAL_OPENED,
	SRA_SUBMIT,
	SHOW_RECOMMENDATIONS,
	RECOMMENDATION_PANEL_ACTION,
	NEXT_STUDENT,
	PREVIOUS_STUDENT
};

const fireEvent = function (name, options = {}, error = false, pubSubOptions = {}) {
	let userContext = model.get('userContext');
	let url = routeContext.path || '';
	let cc = model.get('classCode');
	let uid = userContext ? userContext.uid : undefined;
	let activeProduct = model.get('activeProduct');
	let adblock = !window.adsByGoogleLoaded || !window.showAdsLoaded;
	let eg = model.get('eventExperimentGroup');
	let df = model.get('distractionFreeView') || undefined;
	let wboard = model.get('whiteboardView') || undefined;

	if (routeContext.hash) {
		url += routeContext.hash;
	}

	// Default options
	let defaultOptions = {
		eg,
		df
	};

	switch (name) {
		case NATIVE_PRINT:
		case PRINT:
			if (activeProduct && userContext && !userContext.classCode) {
				analyticsService.activeCampaignEvents({
					event: 'print'
				});

				if (activeProduct.productType === 'AAD') {
					analyticsService.activeCampaignEvents({
						event: 'aad'
					});
				}
			}

			options = _.assign(
				defaultOptions,
				{
					adblock,
					url
				},
				options
			);
			break;

		case OUTBOUND_LINK:
			options = _.assign(
				defaultOptions,
				{
					loc: url
				},
				options
			);
			break;

		case CVA_STUDENT_ANSWER_QUESTION:
			cc = undefined;
			if (userContext && userContext.classCode) {
				cc = userContext.classCode;
			}
			options = _.assign(
				defaultOptions,
				{
					cc
				},
				options
			);
			break;
		case ADD_COTEACHER:
		case ACCEPT_COTEACHER:
		case REMOVE_COTEACHER:
			options = _.assign(
				defaultOptions,
				{
					cc,
					uid
				},
				options
			);
			break;
		case VIDEO_PLAY:
		case VIDEO_PAUSE:
		case VIDEO_COMPLETE:
			options.wboard = wboard;
			if (activeProduct && activeProduct.uuid) {
				options = _.assign(
					defaultOptions,
					{
						pid: activeProduct.uuid
					},
					options
				);
			}
			break;
		case WHITEBOARD_VIEW_ACTIVATE:
			analyticsService.activeCampaignEvents({
				event: 'project'
			});

			if (activeProduct && activeProduct.productType === 'AAD') {
				analyticsService.activeCampaignEvents({
					event: 'aad'
				});
			}

			options = _.assign(defaultOptions, options);

			break;
		case TTS_PLAY:
		case TTS_PAUSE:
		case TTS_COMPLETE:
		case AUDIO_PLAY:
		case AUDIO_PAUSE:
		case AUDIO_COMPLETE:
			if (url.indexOf('student-library') !== -1) {
				options = _.assign(
					defaultOptions,
					{
						library: true
					},
					options
				);
			}
			options = _.assign(defaultOptions, options);
			break;
		default:
			options = _.assign(defaultOptions, options);
	}

	logger.info(name, JSON.stringify(options));
	if (error) {
		return analytics.error(
			name,
			_.assign(options, {
				error: name
			})
		);
	}

	pubSubOptions = Object.assign(
		{},
		{
			name
		},
		options,
		pubSubOptions
	);
	pubsub.publish('analytics-event', pubSubOptions);
	return analytics.event(name, options);
};

const fireError = (name, options) => {
	fireEvent(name, options, true);
};

module.exports = {
	fireEvent,
	fireError,
	events
};

/**
* INVALID EVENT PARAMETERS
	WEB-2502

	'uid',
	'time',
	'timeout',
	'sid',
	'school-info',
	'role',
	'interest-selection',
	'filepath',
	'e',
	'u',
	'd',
	'answerKey',
	'platform',
	'qsid',
	'qid',
	'answerId',
	'id',
	'qnum',
	'href',
	'h',
	'url',
	'v',
	'step',
	'options',
	'stepreadsNumber',
	'user',
	'students',
	'word',
	'value',
	'ss',
	'org',
	'wboard',
	'stepreadsPid',
	'skf',
	'bookmark',
	'favorite',
	'read',
	'note',
	'suids'

**/
